import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/huojian.png'
import _imports_1 from '../assets/image/huojian-1.png'
import _imports_2 from '../assets/image/weixin.png'
import _imports_3 from '../assets/image/weixin-1.png'
import _imports_4 from '../assets/image/footer-type-1.png'
import _imports_5 from '../assets/image/footer-type-2.png'
import _imports_6 from '../assets/image/footer-type-3.png'
import _imports_7 from '../assets/image/back-top1.png'
import _imports_8 from '../assets/image/back-top2.png'
import _imports_9 from '../assets/image/back-top3.png'


const _withScopeId = n => (_pushScopeId("data-v-3f780ccb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "max-section section footer-top" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small-logo-ad" }, "好的像素设计并不是偶然发生的", -1))
const _hoisted_5 = { class: "footer-menu" }
const _hoisted_6 = { class: "item fs-14" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("关于我们")
const _hoisted_8 = { class: "item fs-14" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("用户协议")
const _hoisted_10 = { class: "item fs-14" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("隐私协议")
const _hoisted_12 = { class: "item fs-14" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("支付协议")
const _hoisted_14 = { class: "item fs-14" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("退款政策")
const _hoisted_16 = { class: "share-list" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item row-icon-hover" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://huaban.com/user/xiangsusheji",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "def",
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "act",
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_18 = { class: "item row-icon-hover" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100px"},
  src: "https://pubimg-wfile.xiangsusheji.com/wx_code.png",
  alt: ""
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "def",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "act",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "max-section section footer-btm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "copyint fs-12" }, " 像素设计 津ICP备2023008981号 "),
  /*#__PURE__*/_createElementVNode("div", { class: "copyint-tips fs-12" }, [
    /*#__PURE__*/_createTextVNode(" 像素设计是共享网络服务平台方，平台上的作品均由设计师用户自行上传并发布，若您的权利被侵害，请联系客服邮箱："),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:1241173764@qq.com" }, "1241173764@qq.com"),
    /*#__PURE__*/_createTextVNode("，我们将及时为您处理 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "other-type" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "item row-icon-hover" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_4,
        alt: ""
      }),
      /*#__PURE__*/_createTextVNode("安全支付方式")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "item row-icon-hover" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "item row-icon-hover" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_6,
        alt: ""
      })
    ])
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回顶部", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "back-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  })
], -1))
const _hoisted_25 = { style: {"text-align":"center","display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px","color":"#fff","padding-top":"4px"} }, "人工客服", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "back-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: ""
  })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://support.qq.com/product/618419",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: ""
  })
], -1))
const _hoisted_29 = [
  _hoisted_28
]

import logo from "@/components/logo/index.vue"; // @ is an alias to /src
import { ref, defineComponent } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const openQQ = () => {
  window.open('tencent://message/?Menu=yes&uin=1625793204&Site=像素设计&Service=300&sigT=45a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a595b1714f9d45')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_back_top = _resolveComponent("a-back-top")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(logo),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/recharge" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, { to: "/agreement/user" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, { to: "/agreement/privacy" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, { to: "/agreement/pay" }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_router_link, { to: "/agreement/refund" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_a_tooltip, {
            placement: "top",
            color: "#fff"
          }, {
            title: _withCtx(() => [
              _hoisted_19
            ]),
            default: _withCtx(() => [
              _hoisted_20,
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_22,
    _createVNode(_component_a_back_top, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_tooltip, { placement: "left" }, {
          title: _withCtx(() => [
            _hoisted_23
          ]),
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }),
        _createVNode(_component_a_tooltip, {
          placement: "left",
          getPopupContainer: (trigger) => trigger.parentNode
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_a_image, {
                width: 100,
                preview: false,
                src: "https://pubimg-wfile.xiangsusheji.com/back_top_code.png"
              }),
              _hoisted_26
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }, 8, ["getPopupContainer"]),
        _createElementVNode("div", {
          class: "back-top",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, _hoisted_29)
      ]),
      _: 1
    })
  ]))
}
}

})